import { InputNumber } from 'primereact/inputnumber'
import { useState } from 'react'

import { Input, Spinner } from '../../Components'
import { useAuth } from '../../Provider/AuthProvider'
import { FC } from '../../Services'
import { cap } from '../../State'
import { translations } from '../../translations'
import { alert } from '../AdminCoefficient/Functions'
import { CardResult } from './CardResult'
import { cityOptions, treatmentOptions } from './Functions'

const language = cap.language.state || 'IT'
const t = translations[language]

const checkDateFormat = (date) => /^\d{1,2}-\d{1,2}-\d{4}$/.test(date)

export const HotelServices = (type) => {
  const [checkInDate, setCheckInDate] = useState('15-01-2024')
  const [checkOutDate, setCheckOutDate] = useState('20-01-2024')
  const {
    user: {
      user: {
        environment: { codSociety }
      }
    }
  } = useAuth()
  const [idCommunity, setIdCommunity] = useState(
    codSociety === '90'
      ? '26'
      : import.meta.env.MODE === 'development' || import.meta.env.MODE === 'staging'
        ? '87'
        : '1'
  )
  const [city, setCity] = useState(cityOptions[0].value)
  const [treatment, setTreatment] = useState(' ')
  const [results, setResults] = useState([])
  const [isSearching, setIsSearching] = useState(false)
  const [searchType, setSearchType] = useState('city')
  const [lat, setLat] = useState(0)
  const [lng, setLng] = useState(0)

  const sendRequest = async () => {
    setResults([])
    if (!city) return alert('error', t.tdCittaNonValida)
    if (!checkDateFormat(checkInDate) || !checkDateFormat(checkOutDate))
      return alert('error', t.tdFormatoDateNonValido)
    setIsSearching(true)
    try {
      const res = await FC.service('info').create({
        action: 'previewDynResults',
        serviceType: 'Hotel',
        city:
          searchType === 'city' ? city : { placeDetail: { geometry: { location: { lat, lng } } } },
        checkInDate,
        checkOutDate,
        idCommunity,
        treatment: treatment === ' ' ? '' : treatment
      })
      setResults(res)
    } catch (error) {
      alert('error', t.errore, error?.message || 'Errore durante la ricerca')
    } finally {
      setIsSearching(false)
    }
  }

  return (
    <div className="nsec" style={{ marginBottom: 16 }}>
      <div className="nsec__head">
        <div className="nsec__ico">
          <i className="pi pi-building" style={{ fontSize: 16 }} />
        </div>
        <h3 className="nsec__title">{t.tdHotel}</h3>
        {results.length > 0 && (
          <span className="nbadge nbadge--info" style={{ marginLeft: 8 }}>
            {results.length} {t.tdRisultati}
          </span>
        )}
      </div>
      <div className="nsec__body">
        <div className="testdyn-filters-row">
          <div className="nfield">
            <label htmlFor="idCommunity">{t.tdIdCommunity}</label>
            <Input
              id="idCommunity"
              value={idCommunity}
              onChange={({ idCommunity }) => setIdCommunity(idCommunity)}
              style={{ width: '100%' }}
              onEnter={sendRequest}
            />
          </div>
          <div className="nfield">
            <label htmlFor="searchType">{t.tdTipoRicerca}</label>
            <Input
              id="searchType"
              dropdown
              options={['city', 'coordinates']}
              value={searchType}
              onChange={({ searchType }) => setSearchType(searchType)}
              style={{ width: '100%' }}
              onEnter={sendRequest}
            />
          </div>
          {searchType === 'city' ? (
            <>
              <div className="nfield">
                <label htmlFor="city">{t.tdCitta}</label>
                <Input
                  id="city"
                  dropdown
                  options={cityOptions}
                  value={city}
                  onChange={({ city }) => setCity(city)}
                  style={{ width: '100%' }}
                  onEnter={sendRequest}
                />
              </div>
              <div className="nfield">
                <label>{t.tdCoordinate}</label>
                <span style={{ fontSize: 12, color: 'var(--ink-500)' }}>
                  {t.tdLat}: {city.placeDetail.geometry.location.lat} · {t.tdLng}:{' '}
                  {city.placeDetail.geometry.location.lng}
                </span>
              </div>
            </>
          ) : (
            <>
              <div className="nfield">
                <label htmlFor="lat">{t.tdLatitudine}</label>
                <InputNumber
                  inputId="lat"
                  value={lat}
                  onValueChange={({ value }) => setLat(value)}
                  inputStyle={{ borderRadius: 8, width: '100%' }}
                  maxFractionDigits={10}
                />
              </div>
              <div className="nfield">
                <label htmlFor="lng">{t.tdLongitudine}</label>
                <InputNumber
                  inputId="lng"
                  value={lng}
                  onValueChange={({ value }) => setLng(value)}
                  inputStyle={{ borderRadius: 8, width: '100%' }}
                  maxFractionDigits={10}
                />
              </div>
            </>
          )}
          <div className="nfield">
            <label htmlFor="treatment">{t.tdTrattamento}</label>
            <Input
              id="treatment"
              dropdown
              options={treatmentOptions}
              value={treatment}
              onChange={({ treatment }) => setTreatment(treatment)}
              style={{ width: '100%' }}
              onEnter={sendRequest}
            />
          </div>
          <div className="nfield">
            <label htmlFor="checkInDate">{t.tdDataCheckIn}</label>
            <Input
              value={checkInDate}
              onChange={({ checkInDate }) => setCheckInDate(checkInDate)}
              id="checkInDate"
              onEnter={sendRequest}
              style={{ width: '100%' }}
            />
          </div>
          <div className="nfield">
            <label htmlFor="checkOutDate">{t.tdDataCheckOut}</label>
            <Input
              value={checkOutDate}
              onChange={({ checkOutDate }) => setCheckOutDate(checkOutDate)}
              id="checkOutDate"
              onEnter={sendRequest}
              style={{ width: '100%' }}
            />
          </div>
        </div>
        <div style={{ marginTop: 16 }}>
          {isSearching ? (
            <Spinner />
          ) : (
            <button type="button" className="nbtn nbtn--primary" onClick={sendRequest}>
              <i className="pi pi-search" style={{ fontSize: 14 }} />
              {t.tdCerca}
            </button>
          )}
        </div>
      </div>
      {results.length > 0 && (
        <div className="nsec__body nsec__body--flush">
          <table className="ntable">
            <thead>
              <tr>
                <th>{t.tdHotel}</th>
                <th style={{ width: 160 }}>{t.tdCamera}</th>
                <th style={{ width: 120 }}>{t.tdDistanza}</th>
                <th style={{ width: 120, textAlign: 'right' }}>{t.tdPrezzo}</th>
              </tr>
            </thead>
            <tbody>
              {results.map((result, index) => (
                <tr key={index}>
                  <td>
                    <span style={{ fontWeight: 600 }}>{result.nameHotel}</span>
                  </td>
                  <td>
                    <span style={{ fontSize: 12.5, color: 'var(--ink-700)' }}>
                      {result.typeRoom}
                    </span>
                  </td>
                  <td>
                    <span className="ntable__meta">{parseInt(result?.distanza)} m</span>
                  </td>
                  <td style={{ textAlign: 'right' }}>
                    <span className="ntable__num" style={{ fontWeight: 600 }}>
                      €{result.price}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <div className="testdyn-results-grid">
        {results.map((result, index) => (
          <CardResult key={index} result={result} type={result?.serviceType} />
        ))}
      </div>
    </div>
  )
}
